import orderBy from 'lodash/orderBy'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import ErrorLabel from 'ui/atoms/ErrorLabel'
import TextField from 'ui/molecules/TextField'

import { QuestionInfo } from '@/components/QuestionInfo'
import { TriggerUserActions } from '@/components/TriggerUserActions'
import { getDisabledFlagsByMinAndMax } from '@/utils/getDisabledFlagsByMinAndMax'
import cn from '@/utils/tailwind/cn'

import Checkbox from './Checkbox'
import { FakeInput } from './form/FakeInput'
import { QuestionTitle } from './Text'

export function HorizontalCheckboxQuestionRenderer({
  details = {},
  errorMessage,
  getChoiceDetails = () => '',
  getValue = () => false,
  hasError,
  isOfficeUse,
  isRequired,
  label,
  onChange = () => {},
  onUpdateDetails = () => {},
  questionChoices,
  readonly,
  willShowNotAllowedCursor,
  questionId,
  response,
  sessions,
  question,
  totalAnswerChoices,
}) {
  const history = useHistory()
  const isBuilderForm = history?.location?.pathname?.includes('/forms/')

  const { disableMin, disableMax, greaterThanMax } =
    getDisabledFlagsByMinAndMax({
      min: question?.min_value,
      max: question?.max_value,
      total: totalAnswerChoices,
    })
  const hasAnswer = Boolean(totalAnswerChoices)

  let shouldShowRangeTextOnlyBuilder = false
  if ((question?.min_value || question?.max_value) && isBuilderForm) {
    shouldShowRangeTextOnlyBuilder = true
  }

  let rangeText = ''
  if (question?.min_value && question?.max_value) {
    rangeText = `You must select between ${question?.min_value} and ${question?.max_value} options`
  } else if (question?.min_value) {
    rangeText = `The minimum required number of selections is ${question?.min_value}`
  } else if (question?.max_value) {
    rangeText = `You can select up to ${question?.max_value} options`
  }

  let shouldShowRangeText = false
  if (
    (disableMin || disableMax || shouldShowRangeTextOnlyBuilder) &&
    (hasAnswer || isBuilderForm) &&
    !greaterThanMax
  ) {
    shouldShowRangeText = true
  }

  return (
    <div>
      <div>
        {label && (
          <QuestionTitle isOfficeUse={isOfficeUse} isRequired={isRequired}>
            {label}
          </QuestionTitle>
        )}
        <div className="flex flex-wrap gap-x-4 gap-y-[3px]">
          {orderBy(questionChoices, ['order'], ['asc']).map((choice) => {
            let isChoiceSelectedAndRequiresDetails = false
            if (getValue(choice.id) && choice.request_details) {
              isChoiceSelectedAndRequiresDetails = true
            }

            const requiresDetailsStyle = {
              'flex-col': isChoiceSelectedAndRequiresDetails,
            }
            return (
              <div
                className={cn('flex space-x-2', requiresDetailsStyle)}
                key={choice.value}
              >
                <TriggerUserActions>
                  <Checkbox
                    noMargin
                    checked={getValue(choice.id)}
                    data-form-id={response?.form?.id}
                    data-packet-id={
                      sessions?.fillResponseCustomer?.packetResponse?.packet?.id
                    }
                    data-response-id={response?.id}
                    disabled={readonly}
                    id={`q-${questionId}-c-${choice.id}`}
                    label={choice.text_value}
                    onChange={(v) => onChange(choice.id, v)}
                    willShowNotAllowedCursor={willShowNotAllowedCursor}
                  />
                </TriggerUserActions>
                {getValue(choice.id) && choice.request_details && (
                  <div className="mb-2 flex-1 !pl-5">
                    {readonly && getChoiceDetails?.(choice.id) ? (
                      <FakeInput>{getChoiceDetails?.(choice.id)}</FakeInput>
                    ) : null}

                    {!readonly ? (
                      <TextField
                        className="min-h-[38px]"
                        onBlur={() =>
                          onChange(choice.id, true, details[choice.id])
                        }
                        onChange={(value) => onUpdateDetails(choice.id, value)}
                        placeholder="Details"
                        value={getChoiceDetails?.(choice.id)}
                      />
                    ) : null}
                  </div>
                )}
              </div>
            )
          })}
        </div>
        {shouldShowRangeText ? (
          <QuestionInfo className="mt-1">{rangeText}</QuestionInfo>
        ) : null}
      </div>
      {hasError && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}

export default HorizontalCheckboxQuestionRenderer
